import { Col, Row } from 'reactstrap';
import { capitalizeFirstLetter } from 'src/utils/string';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';

const Search = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const handleAreaChange = (value) => {
    model.getModel('area').requestChange(value);

    if (!value || (Array.isArray(value) && value.length === 0)) {
      model.getModel('areasSubordinadas').requestChange(false);
    }
  };

  return (
    <Row>
      <Col md={12}>
        <Input model={model.getModel('nome')} />
      </Col>
      <Col md={12}>
        <Input model={model.getModel('idIntegracao')} />
      </Col>
      <Col md={12}>
        <ItemOrganizacaoLookup
          model={{
            label: capitalizeFirstLetter(resources.area),
            value: model.getModel('area').value,
            requestChange: handleAreaChange,
          }}
          data={{ tiposIdSelecionaveis: [1, 2, 3] }}
          clearable
        />
      </Col>

      <Col md={12}>
        <Checkbox
          model={{
            label: intl.formatMessage(
              { id: 'label.considerarAreasSubordinadas' },
              { areas: resources.areas }
            ),
            value: model.getModel('areasSubordinadas').value,
            requestChange: model.getModel('areasSubordinadas').requestChange,
          }}
          disabled={!model.getModel('area').value}
          className="mb-3"
        />
      </Col>
    </Row>
  );
};

export default Search;
